
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 24 24"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M6 24c-.253 0-.505-.044-.749-.13a.751.751 0 01-.12-.044l-.006-.003A2.246 2.246 0 013.75 21.75v-2.367c0-3.133 1.806-5.998 4.572-7.383C5.556 10.615 3.75 7.75 3.75 4.617V2.25A2.252 2.252 0 016 0h12a2.252 2.252 0 012.25 2.25v2.367c0 3.133-1.805 5.998-4.572 7.383 2.767 1.385 4.572 4.25 4.572 7.383v2.367a2.244 2.244 0 01-1.457 2.104c-.25.095-.52.146-.793.146H6zm11.345-1.5c-1.161-1.902-3.08-3.75-5.345-3.75-2.265 0-4.185 1.848-5.345 3.75h10.69zm-6.65-9.738a6.75 6.75 0 00-5.445 6.621v2.367c0 .052.005.103.016.152C6.643 19.562 9.04 17.25 12 17.25c2.959 0 5.357 2.311 6.734 4.652.01-.05.016-.1.016-.152v-2.367c0-3.226-2.286-6-5.445-6.621a8.258 8.258 0 01-2.61 0zM12 11.133c.43 0 .869.035 1.305.105A6.803 6.803 0 0017.127 9H6.873a6.8 6.8 0 003.822 2.238c.436-.07.875-.105 1.305-.105zM18.101 7.5a6.656 6.656 0 00.649-2.883V2.25A.75.75 0 0018 1.5H6a.75.75 0 00-.75.75v2.367c0 1.009.218 1.977.649 2.883h12.202z"}})])
          )
        }
      }
    